"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var PriceBookSelect = /** @class */ (function (_super) {
    __extends(PriceBookSelect, _super);
    function PriceBookSelect() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PriceBookSelect.prototype.mounted = function () {
        this.handleInput(this.value);
    };
    PriceBookSelect.prototype.handleInput = function (newVal) {
        this.$emit('input', newVal);
        this.$emit('price-book-change', this.getPriceBookInfo(newVal));
    };
    PriceBookSelect.prototype.getPriceBookInfo = function (priceBookId) {
        var currentPriceBook = this.priceBookItems.filter(function (priceBook) {
            return priceBook['value'] === priceBookId;
        });
        if (currentPriceBook.length) {
            return {
                name: currentPriceBook[0]['text'],
                description: currentPriceBook[0]['Description'],
                url: currentPriceBook[0]['DisplayURL'],
                cancelFlg: currentPriceBook[0]['CancelFlag'],
                BillWay: currentPriceBook[0]['BillWay']
            };
        }
        else {
            return {};
        }
    };
    __decorate([
        vue_property_decorator_1.Prop({ default: [] })
    ], PriceBookSelect.prototype, "priceBookItems", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: '' })
    ], PriceBookSelect.prototype, "value", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: false })
    ], PriceBookSelect.prototype, "disabled", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: '' })
    ], PriceBookSelect.prototype, "hint", void 0);
    PriceBookSelect = __decorate([
        vue_property_decorator_1.Component
    ], PriceBookSelect);
    return PriceBookSelect;
}(vue_property_decorator_1.Vue));
exports.default = PriceBookSelect;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/sales_force/PriceBookSelect.vue
// module id = 4aCm
// module chunks = 1